<template>
    <div>
        <div v-if="!openPatientCard" class="w3-col w3-margin-bottom w3-center flow-padding-bottom">
            <h5 v-if="noRoomsLinked" class="flow-blue-color zero-bottom zero-top">

                <p class="zero">
                    <i class="fa fa-exclamation-triangle w3-text-deep-orange flow-margin-right"></i>
                    <span class="w3-text-red font-weight-bold w3-margin-right w3-hover-opacity-off">
                        {{ $t('noRoomsLinked') }}. {{ $t('linkRoomInfo') }}
                    </span>

                    <router-link :to="{name: 'rooms'}" class="flow-btn w3-btn w3-round-medium flow-blue-color">
                        <i class="fa fa-door-open flow-green-active-color"></i>
                        {{ $t('link') }}
                        <i class="fa fa-chevron-right"></i>
                    </router-link>
                </p>

            </h5>

            <span v-else
                  v-for="room in rooms"
                  v-bind:class="currentRoomId === room.id ? 'w3-opacity-off active halo-box' : 'w3-opacity-super-min'"
                  @click="switchRoom(room)"
                  class="consultation-room flow-btn w3-round-medium font-weight-bold w3-padding cursor-pointer w3-margin-right flow-blue-color w3-large">
                    {{room.displayName}}
            </span>
        </div>

        <div v-bind:class="openPatientCard ? 'w3-container content-sidebars sidebars-50-50' : 'flow-main-content w3-margin-bottom'">
            <div v-show="!openPatientCard" class="flow-card blue-top w3-col" style="min-height: 300px">

                <ongoing-consultation-card
                        :isCallerActive="isPhysicianActive"
                        :ongoing="ongoing"
                        :roomActions="roomActionsList"
                        :consultationGroup="roomGroup" :noRoomsLinked="noRoomsLinked">
                </ongoing-consultation-card>


                <h5 v-if="!ongoing && blockingCall && !blockingCallRemoved" class="flow-blue-color w3-center">
                    <!--fetch the call blocking this room and show the message is its there.-->
                    <button class="flow-badge w3-padding w3-round-medium">
                        {{$t("patientWaitingForYou", {'patient' : blockingCall.patientName, 'room' : blockingCall.calledTo.name})}}
                    </button>
                    <button class=" w3-margin-left flow-btn w3-btn w3-border w3-round-medium" @click="deleteBlockingCall">
                        <i class="fa fa-check-circle flow-green-active-color"></i>
                        {{$t('goToExamRoom')}}
                    </button>
                </h5>

                <h5 v-if="isAssistedExit"
                    class="flow-blue-color w3-center">
                    <button class=" w3-margin-left flow-btn w3-btn w3-border w3-round-medium w3-deep-orange font-weight-bold" @click="moveOutOfConsultation">
                        {{ $t('MoveOutOfConsultation') }}
                    </button>
                </h5>


            </div>

            <div v-bind:class="openPatientCard ? 'zero w3-col content-sidebar-left' : 'w3-col w3-margin-top w3-margin-bottom'">
                <patients-for-caller :room="currentRoom" :patients="patients" :onSelectCallback="openPatient" :isShared="false" :openPatientCard="openPatientCard" :physician="physician"></patients-for-caller>
            </div>

            <div v-if="openPatientCard"
                 class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
                <patient-side-card class="flow-padding-top"
                                   :selectedPatient="selectedPatient"
                                   :selectedPatientStatus="selectedPatient.status"
                                   :selectedPatientDevice="selectedPatient.device"
                                   :onClose="() => {openPatientCard = false;}"></patient-side-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ContentHeader from "../common/ContentHeader";
    import PatientSideCard from "../patient/PatientSideCard";
    import PatientsForCaller from "./PatientsForCaller";
    import OngoingConsultationCard from "./OngoingConsultationCard";
    import Loading from "../common/Loading";
    import { EventBus } from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationInRoom",
        props: ['roomId', 'propsPhysician'],
        components: {
            Loading, OngoingConsultationCard, PatientSideCard, PatientsForCaller, ContentHeader
        },
        data() {
            return {
                rooms: [],
                physician: {},
                currentRoomId: undefined,
                patients: [],
                wardId: undefined,
                roomActions: [],
                ongoing: undefined,
                openPatientCard: false,
                selectedPatient: {},
                refreshIntervalId: undefined,
                patientRefreshIntervalId: undefined,
                blockingCall: undefined,
                blockingCallRemoved: false,
                currentRoom: undefined
            }
        },
        computed: {
            patientTitle() {
                if (!this.ongoing || !this.ongoing.patient) {
                    return "";
                }
                const patient = this.ongoing.patient;

                return Vue.patientNamePlusId(patient.name, patient.internalIds)
            },
            appointment() {
                return this.ongoing ? this.ongoing.appointment : undefined;
            },
            patient() {
                return this.ongoing ? this.ongoing.patient : undefined;
            },
            isPhysicianActive() {
                return this.physician && this.physician.status === 'Active';
            },
            noRoomsLinked() {
                return this.rooms.length === 0;
            },
            roomGroup() {
                return this.currentRoom ? this.currentRoom.group : {};
            },
            isAssistedExit() {
                return this.ongoing
                    && this.currentRoom
                    && this.currentRoom.assisted === false
                    && this.appointment
                    && this.appointment.appointmentStatus === 'Opened'
                    && this.appointment.checkupStatus === 'Ending';
            },
            roomActionsList() {
                return this.isAssistedExit ? [] : this.roomActions;
            }
        },
        mounted() {
            if (this.roomId) {
                this.currentRoomId = this.roomId;
            }

            if (!this.propsPhysician) {
                Vue.notifyError({
                    title: this.$t("NO_PHYSICIAN_LINKED")
                });
                return;
            }

            this.physician = this.propsPhysician;
            var rooms = this.physician.rooms;
            if (!this.currentRoomId && rooms && rooms.length > 0) {
                this.currentRoomId = rooms[0].id;
            }

            this.wardId = this.physician.ward.id;
            this.getOngoingConsultationInRoom();
            this.getBlockingCall();

            this.refreshIntervalId = setInterval(this.refresh, 8000);
            this.patientRefreshIntervalId = setInterval(this.refreshPatients, 5000);
            EventBus.$on("patientUpdated", this.onPatientUpdate);
            EventBus.$on("onClickCallerStatusChange", this.togglePhysicianStatus);
            EventBus.$on("onClickRoomAction", this.runRoomAction);
            EventBus.$on("manuallyCalledPatient", this.getOngoingConsultationInRoom);
        },
        beforeDestroy() {
            clearInterval(this.refreshIntervalId);
            clearInterval(this.patientRefreshIntervalId);
            EventBus.$off("patientUpdated", this.onPatientUpdate);
            EventBus.$off("onClickCallerStatusChange", this.togglePhysicianStatus);
            EventBus.$off("onClickRoomAction", this.runRoomAction);
            EventBus.$off("manuallyCalledPatient", this.getOngoingConsultationInRoom);
        },
        watch: {
            physician() {
                this.physician.active = this.physician.status === 'Active';
                this.getPatientsForPhysician();

                var rooms = this.physician ? this.physician.rooms : undefined;
                if (!rooms || rooms.length < 1) {
                    this.rooms = [];
                    return;
                }

                Vue.sortByKey(rooms, 'displayName');
                this.rooms = rooms;
            },
            currentRoomId() {
                this.getAndSetCurrentRoomWithGrp();
                this.getRoomActions();
            },
            rooms() {
                if (!this.currentRoomId && this.rooms && this.rooms.length > 0) {
                    this.currentRoomId = this.rooms[0].id;
                }
            }
        },
        methods: {
            refresh() {
                this.getPhysician();
                this.getOngoingConsultationInRoom();
                this.getBlockingCall();
            },
            refreshPatients() {
                this.getPatientsForPhysician();
            },
            getBlockingCall() {
                if (!this.currentRoomId) {
                    return;
                }

                var app = this;
                app.blockingCallRemoved = false;
                frc.getBlockingCallOnThisRoom(app.physician.ward.id, app.currentRoomId).then(function (res) {
                    app.blockingCall = res.data;
                });
            },
            getRoomActions() {
                const app = this;
                frc.getRoomActions(this.wardId, this.currentRoomId).then(function (res) {
                    app.roomActions = res.data;
                });
            },
            getOngoingConsultationInRoom() {
                if (!this.currentRoomId) {
                    return;
                }

                const app = this;
                frc.getOngoingConsultationInRoom(this.wardId, this.currentRoomId).then(function (res) {
                    app.ongoing = res.data;
                });
            },
            getPatientsForPhysician() {
                const app = this;
                frc.getPatientsForPhysician(this.wardId, this.physician.id).then(function (res) {
                    app.patients = res.data;
                });
            },
            togglePhysicianStatus() {
                var promise = undefined;
                const app = this;

                if (this.isPhysicianActive) {
                    promise = frc.pausePhysician(this.wardId, this.physician.id);
                } else {
                    promise = frc.activatePhysician(this.wardId, this.physician.id);
                }

                promise.then(function(res) {
                    app.getPhysician();
                    app.getOngoingConsultationInRoom();
                });
            },
            getPhysician() {
                const app = this;
                frc.getPhysicianWithId(app.physician.id).then(function(res) {
                    app.physician = res.data;
                });
            },
            getPhysicianInRoom() {
                const app = this;

                frc.getPhysicianInRoom(this.wardId, this.currentRoomId).then(function (res) {
                    app.physician = res.data;
                });
            },
            runRoomAction(roomAction) {
                const app = this;

                if ("true" === Vue.getRoomActionUISetting(roomAction, 'pauseCaller', "false")) {
                    frc.pausePhysician(this.wardId, this.physician.id).then(function(res) {
                        app._runRoomAction(roomAction);
                        app.getPhysician();
                    }).catch(function(ex) {
                        Vue.notifyError({
                            title: app.$t("failedToPause")
                        });
                        app._runRoomAction(roomAction);
                    });
                } else {
                    app._runRoomAction(roomAction);
                }
            },
            _runRoomAction(roomAction) {
                const app = this;

                frc.runRoomAction(this.wardId, this.currentRoomId, this.appointment.id, roomAction.id).then(function (res) {
                    Vue.notifySuccess({
                        title: app.$t("success"),
                        message: roomAction.displayName
                    });

                    app.getOngoingConsultationInRoom();
                });
            },
            openPatient(patient) {
                this.selectedPatient = patient;
                this.openPatientCard = true;
            },
            switchRoom(newRoom) {
                this.currentRoomId = newRoom.id;
                this.ongoing = undefined;
                this.refresh();
            },
            updateStatus(patientId) {
                var app = this;
                frc.getPatientInWard(Vue.prototype.$currentWard.id , patientId).then(function (res) {
                    if (!res.data) {
                        console.log("Patient not found.");
                        return;
                    }
                    app.selectedPatient.status = res.data.status;
                });
            },
            deleteBlockingCall() {
                var app = this;
                frc.deleteBlockingCallOnThisRoom(app.wardId, app.currentRoomId).then(function (res) {
                    app.blockingCallRemoved = true;
                    app.getOngoingConsultationInRoom();
                });
            },
            getAndSetCurrentRoomWithGrp() {
                var app = this;
                app.currentRoom = undefined;
                frc.getConsultationRoomInWard(app.wardId, app.currentRoomId).then(function(res) {
                    app.currentRoom =  res.data;
                });
            },
            onPatientUpdate(patientId) {
                this.updateStatus(patientId);
                this.getOngoingConsultationInRoom();
            },
            moveOutOfConsultation() {
                if (!this.ongoing || !this.appointment || !this.patient) {
                    Vue.notifyError({
                        title: this.$t("failedToUpdate")
                    });
                }

                var app = this;
                frc.safelyMoveOutOfConsultation(this.patient.id, this.appointment.id).then(function(res) {
                    Vue.notifySuccess({
                        title: app.$t('successfullyUpdated')
                    });
                    app.getOngoingConsultationInRoom();
                });

            }
        }
    }
</script>

<style scoped>

</style>